import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	issueIconAltText: {
		id: 'command-palette-common.common.command.project.project-left-icon.issue-icon-alt-text',
		defaultMessage: 'Icon for the project {name}',
		description: 'Alternate text for the icon displayed next to the project',
	},
});
